import RegionList from "../../slices/sales/region/RegionList";
import RegionDetails from "../../slices/sales/region/RegionDetails";
import GradeList from "../../slices/sales/grade/GradeList";
import GradeDetails from "../../slices/sales/grade/GradeDetails";
import CustomerCategoryList from "../../slices/sales/customer_category/CustomerCategoryList";
import CustomerCategoryDetails from "../../slices/sales/customer_category/CustomerCategoryDetails";
import CustomerGroupList from "../../slices/sales/customer_group/CustomerGroupList";
import CustomerGroupDetails from "../../slices/sales/customer_group/CustomerGroupDetails";
import CustomerTypeList from "../../slices/sales/customer_type/CustomerTypeList";
import CustomerTypeDetails from "../../slices/sales/customer_type/CustomerTypeDetails";
import CategoryList from "../../slices/sales/category/CategoryList";
import CategoryDetails from "../../slices/sales/category/CategoryDetails";
import CustomerList from "../../slices/sales/customer/CustomerList";
import CustomerDetails from "../../slices/sales/customer/CustomerDetails";
import CustomerDispatchDetails from "../../slices/sales/customer/CustomerDispatchDetails";
import CustomerRouteAssignmentList from "../../slices/sales/customer_route_assignment/CustomerRouteAssignmentList";
import CustomerRouteAssignmentDetails from "../../slices/sales/customer_route_assignment/CustomerRouteAssignmentDetails";
import RoutesList from "../../slices/sales/routes/RoutesList";
import RoutesDetails from "../../slices/sales/routes/RoutesDetails";
import RoutesPosition from "../../slices/sales/routes/RoutesPosition";
import CustomerRoutesPosition from "../../slices/sales/routes/CustomerRoutesPosition";
import SalesOrderList from "../../slices/sales/sales_order/SalesOrderList";
import SalesOrderDetails from "../../slices/sales/sales_order/SalesOrderDetails";
import ProductPricingWithFilters from "../../slices/sales/sales_order/ProductPricingWithFilters";
import DispatchAdviceRoutesList from "../../slices/sales/sales_order/DispatchAdviceRoutesList";
import DispatchPlanningList from "../../slices/sales/dispatch_planning/DispatchPlanningList";
import DispatchPlanningDetails from "../../slices/sales/dispatch_planning/DispatchPlanningDetails";
import DispatchPlanningCustomer from "../../slices/sales/dispatch_planning/DispatchPlanningCustomer";
import VehicleList from "../../slices/sales/vehicle/VehicleList";
import VehicleDetails from "../../slices/sales/vehicle/VehicleDetails";
import DispatchAdviceList from "../../slices/sales/dispatch_advice/DispatchAdviceList";
import SalesOrderItems from "../../slices/sales/dispatch_advice/SalesOrderItems";
import DispatchAdviceDetails from "../../slices/sales/dispatch_advice/DispatchAdviceDetails";
import PaymentTermsList from "../../slices/sales/payment_terms/PaymentTermsList";
import PaymentTermsDetails from "../../slices/sales/payment_terms/PaymentTermsDetails";
import DeliveryPlanningList from "../../slices/sales/delivery_planning/DeliveryPlanningList";
import DeliveryPlanningDetails from "../../slices/sales/delivery_planning/DeliveryPlanningDetails";
import DeliveryPlanningPosition from "../../slices/sales/delivery_planning/DeliveryPlanningPosition";
import VehicleWareHouseList from "../../slices/sales/delivery_planning/VehicleWareHouseList";
import VehicleWareHouseItemList from "../../slices/sales/delivery_planning/VehicleWareHouseItemList";
import StockTransferList from "../../slices/sales/stock_transfer/StockTransferList";
import StockTransferDetails from "../../slices/sales/stock_transfer/StockTransferDetails";
import VanSalePlanningList from "../../slices/sales/stock_transfer/VanSalePlanningList";
import SuggestionItemList from "../../slices/sales/stock_transfer/SuggestionItemList";
import ItemBifurcateDetails from "../../slices/sales/stock_transfer/ItemBifurcateDetails";
import SalesTargetFilter from "../../slices/sales/sales_target/SalesTargetFilter";
import SalesTargetList from "../../slices/sales/sales_target/SalesTargetList";
import SalesTargetDetails from "../../slices/sales/sales_target/SalesTargetDetails";
import MerchandiseRackList from "../../slices/sales/merchandise_rack/MerchandiseRackList";
import MerchandiseRackDetails from "../../slices/sales/merchandise_rack/MerchandiseRackDetails";
import MerchandiseRackByCustomer from "../../slices/sales/merchandise_rack/MerchandiseRackByCustomer";
import TourPlanList from "../../slices/sales/tour_plan/TourPlanList";
import TourPlanDetails from "../../slices/sales/tour_plan/TourPlanDetails";
import CustomerBySales from "../../slices/sales/tour_plan/CustomerBySales";
import WarehouseStockItemList from "../../slices/sales/return_item/WarehouseStockItemList";
import VanStockReportList from "../../slices/sales/van_stock_report/VanStockReportList";

const salesReducer = {
    regionList: RegionList,
    regionDetails: RegionDetails,
    gradeList: GradeList,
    gradeDetails: GradeDetails,
    customerCategoryList: CustomerCategoryList,
    customerCategoryDetails: CustomerCategoryDetails,
    customerGroupList: CustomerGroupList,
    customerGroupDetails: CustomerGroupDetails,
    customerTypeList: CustomerTypeList,
    customerTypeDetails: CustomerTypeDetails,
    categoryList: CategoryList,
    categoryDetails: CategoryDetails,
    customerList: CustomerList,
    customerDetails: CustomerDetails,
    customerDispatchDetails: CustomerDispatchDetails,
    customerRouteAssignmentList: CustomerRouteAssignmentList,
    customerRouteAssignmentDetails: CustomerRouteAssignmentDetails,
    routesList: RoutesList,
    routeDetails: RoutesDetails,
    routePosition: RoutesPosition,
    customerRoutesPosition: CustomerRoutesPosition,
    salesOrderList: SalesOrderList,
    salesOrderDetails: SalesOrderDetails,
    productPricingWithFilter: ProductPricingWithFilters,
    dispatchAdviceRouteList: DispatchAdviceRoutesList,
    dispatchPlanningList: DispatchPlanningList,
    dispatchPlanningDetails: DispatchPlanningDetails,
    dispatchPlanningCustomer: DispatchPlanningCustomer,
    vehicleList: VehicleList,
    vehicleDetails: VehicleDetails,
    dispatchAdviceList: DispatchAdviceList,
    dispatchAdviceDetails: DispatchAdviceDetails,
    salesOrderItems: SalesOrderItems,
    paymentTermsList: PaymentTermsList,
    paymentTermsDetails: PaymentTermsDetails,
    deliveryPlanningList: DeliveryPlanningList,
    deliveryPlanningDetails: DeliveryPlanningDetails,
    deliveryPlanningPosition: DeliveryPlanningPosition,
    vehicleWareHouseList: VehicleWareHouseList,
    vehicleWareHouseItemList: VehicleWareHouseItemList,
    stockTransferList: StockTransferList,
    stockTransferDetails: StockTransferDetails,
    vanSalePlanningList: VanSalePlanningList,
    suggestionItemList: SuggestionItemList,
    itemBifurcateDetails: ItemBifurcateDetails,
    salesTargetFilter: SalesTargetFilter,
    salesTargetList: SalesTargetList,
    salesTargetDetails: SalesTargetDetails,
    merchandiseRackList: MerchandiseRackList,
    merchandiseRackDetails: MerchandiseRackDetails,
    merchandiseRackByCustomer: MerchandiseRackByCustomer,
    tourPlanList: TourPlanList,
    tourPlanDetails: TourPlanDetails,
    customerBySales: CustomerBySales,
    warehouseStockItemList: WarehouseStockItemList,
    vanStockReportList: VanStockReportList,
};

export default salesReducer;